import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import ShipInfoLoading from "areas/product/jewlr/loaders/ship-info-loading"
import { retry, IS_GE_CHECKOUT } from "helpers/application"
import { cn } from "styles/utils"

import ShipDetails from "./ship-details"
import Title from "./title"

const InstantGiftPreview = loadable(() =>
  retry(() => import("areas/instant-gift/explained/modal"))
)

const Container = ({ className = "", ...props }) => (
  <div
    className={cn(
      // "mb-18 tablet:bg-grey-4 tablet:py-30 tablet:px-24 bg-(--color-light-green) px-20 py-16 text-center",
      "mb-18 bg-grey-4 tablet:py-30 tablet:px-24 px-20 py-16 text-center",
      className
    )}
    // style={{ "--color-light-green": "#d7f3b9" }}
    {...props}
  />
)

Container.propTypes = {
  className: PropTypes.string,
}

const InternalShipping = ({ ship, wizardLoading }) => {
  const is_ge_checkout = IS_GE_CHECKOUT()

  if (is_ge_checkout) return ""

  if (!ship || wizardLoading) {
    return (
      <Container className="flex items-center" style={{ minHeight: "130px" }}>
        <div className="w-full">
          <ShipInfoLoading />
        </div>
      </Container>
    )
  }

  // if ship.ship_days <= 2
  // <>
  //   <p className="text-16 mb-3 text-black">Custom made for you in</p>
  //   <div className="flex items-center justify-center">
  //     <Image
  //       className="mr-8 w-auto"
  //       height="881"
  //       src={require("images/icons/quick_ship_green.svg")}
  //       style={{ height: "24px" }}
  //       width="922"
  //     />
  //     <p className="text-green-darker text-30 font-light">
  //       {ship.ship_days < 1 ? "1" : ship.ship_days} DAY
  //       {ship.ship_days > 1 && "S"}
  //     </p>
  //   </div>
  // </>

  return (
    <Container id="shipping_options_container">
      <Title />
      <ShipDetails />
      <InstantGiftPreview />
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    ship: state.wizard.shipping.main,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalShipping.propTypes = {
  ship: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const Shipping = connect(mapStateToProps, mapDispatchToProps)(InternalShipping)

export default Shipping
